import React from 'react';
import { AdminNavbar, AddBlogForm } from '..';

export const AddBlogsPage: React.FC = React.memo(() => {
    return (
        <>
            <AdminNavbar addBlog />
            <AddBlogForm />
        </>
    );
});
